import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { GrupoClassificacaoClassificavelFormModule } from '../../../grupo-classificacao/classificavel/form';
import { RepresentanteClassificacaoClienteFormComponent } from './form';

@NgModule({
    imports: [
        SharedModule,
        GrupoClassificacaoClassificavelFormModule
    ],
    declarations: [
        RepresentanteClassificacaoClienteFormComponent
    ],
    exports: [
        RepresentanteClassificacaoClienteFormComponent
    ]
})
export class RepresentanteClassificacaoClienteFormModule { }
